import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { Form, Text, Select } from 'react-form';
import { api } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoList, PropsList, StateList } from '@src/components/Proto';
import { SettingsTruck as Edit, Box } from '@src/components';
import { isReadOnly } from 'services/user';

// typing
interface LocalProps extends PropsList {
    
}
interface LocalState extends StateList {
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Truck extends ProtoList<LocalProps, LocalState> {
    
	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { cpt, urlShow, urlCreate, urlUpdate } = this.props;
        const { loading, action, editing, data, search = {}, items = [], tableProps, editProps } = this.state;

        const customers = data.customers.map( v => ({ value: v.id, label: v.name }));
        const brands = data.brands.map( v => ({ value: v.id, label: v.name }));
        
        const columns = [
            { ...defaultProps.columns.id, accessor: 'truckid' },
            { Header: _('col_serialno', 'SettingsTruck'), accessor: 'serialno' },
            { Header: _('col_seriescode', 'SettingsTruck'), accessor: 'seriescode' },
            { Header: _('col_type', 'SettingsTruck'), accessor: 'type' },
        ];
        
        let localTableProps;
        if (items) {
            localTableProps = {
                ...defaultProps.table(),
                ...tableProps,
            }
        }
        localTableProps.loading = loading;
        
        let localEditProps = {
            ...editProps
        } as any;
        if (action === "EDIT" && !isReadOnly() ) {
            localEditProps.id = editing;
        }

		return (
            <>
            {(action === "CREATE" || action === "EDIT") && !isReadOnly() &&
            <Edit {...localEditProps} />
            }
            <Box
                title={_('list_title', 'SettingsTruck')}
                toolbar={!isReadOnly()?this.Toolbar:null}
                collapsed={false}
            >
                <div className={style}>
                    <Form onSubmit={(v) => this.search(v)}>
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onChange={() => setTimeout(() => { this.setState({ filters: formApi.getFormState().values }); }) }
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="serialno">{_('field_serialno', 'SettingsTruck')}</label>
                                    <Text field="serialno" id="serialno" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="seriescode">{_('field_seriescode', 'SettingsTruck')}</label>
                                    <Text field="seriescode" id="seriescode" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="model">{_('field_model', 'SettingsTruck')}</label>
                                    <Text field="model" id="model" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="type">{_('field_type', 'SettingsTruck')}</label>
                                    <Text field="type" id="type" className="form-control" />
                                </article>
                            </div>
                            <footer>
                                <span />
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_search`, 'Settings')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Box>
            
            <ReactTable
                {...localTableProps}
                data={items}
                columns={columns}
            />

            </>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/List/Truck.tsx